<template>
    <div class="error-message">
        <div
            v-for="error in formTarget"
            v-if="formTarget"
            :key="error"
            class="invalid-feedback" style="display:block"
            v-html="error"
        >
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormErrorMessage',
    props: {
        formTarget: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
